import { FETCH_GROUPS_FAIL } from 'constants/actionTypes/groups'

export default function failAction(error) {
  return { type: FETCH_GROUPS_FAIL, payload: { err: error } }
}
